<template>
  <div
    class="mx-auto"
    :class="$style['box']"
  >
    <div class="pb-8 mt-8 px-6 max-w-lg mx-auto md:mt-16 md:pb-8 text-center">
      <div class="text-primary-blue text-xl mb-4 md:mb-8">
        Estos son los datos de tu reserva:
      </div>

      <ul
        class="text-sm pl-6 mb-6 sm:mb-12"
        style="list-style: none"
      >
        <!-- <li class="pl-2 my-1">
          <span class="font-bold">Ubicación:</span> {{ concessionary.name }}
        </li> -->

        <li class="pl-2 my-1">
          <span class="font-bold">Localidad:</span> {{ activity.city }}
        </li>

        <li class="pl-2 my-1">
          <span class="font-bold">Dirección:</span> {{ activity.address }}
        </li>

        <li class="pl-2 my-1">
          <span class="font-bold">Vehículo:</span> {{ activity.vehicle }}
        </li>

        <li class="pl-2 my-1">
          <span class="font-bold">Fecha:</span> {{ activity.date }}
        </li>

        <li class="pl-2 my-1">
          <span class="font-bold">Hora:</span> {{ activity.schedule }}
        </li>
      </ul>

      <div class="sm:flex px-12 md:px-16">
        <VButton
          tag="link"
          theme="fill"
          :href="'https://events.eventos-audi.com/' + concessionary.slug + '/ticket/' + attendeeUuid + '/pdf'"
          target="_blank"
          class="block sm:flex-1 md:w-auto md:text-base font-text my-3 sm:mr-4"
        >
          Descargar reserva en PDF
        </VButton>

        <VButton
          tag="link"
          theme="fill"
          :href="'https://events.eventos-audi.com/' + concessionary.slug + '/ticket/' + attendeeUuid + '/calendar'"
          target="_blank"
          class="block sm:flex-1 md:w-auto md:text-base font-text my-3 sm:mr-4"
        >
          Añadir a mi calendario
        </VButton>

        <VButton
          tag="link"
          theme="fill"
          :href="'https://events.eventos-audi.com/' + concessionary.slug + '/ticket/' + attendeeUuid + '/passbook'"
          target="_blank"
          class="block sm:flex-1 md:w-auto md:text-base font-text my-3"
        >
          Descargar Passbook
        </VButton>
      </div>
    </div>
  </div>
</template>

<script>
import { DateTime } from 'luxon'

import {
  VButton
} from '@c/base'

export default {
  components: {
    VButton
  },

  props: {
    attendee: {
      type: Object,
      default: null
    },

    bookingData: {
      type: Object,
      default: null
    }
  },

  computed: {
    attendeeUuid () {
      return this.attendee ? this.attendee.data.id : ''
    },

    activity () {
      if (this.bookingData) {
        let data = this.bookingData

        data.date = DateTime.fromFormat(data.date, 'yyyy-LL-dd').toFormat('DD')

        return data
      }

      return {}
    },

    concessionary () {
      if (Object.keys(this.activity).length > 0) {
        return this.activity.concessionary
      }

      return {}
    }
  },

  beforeCreate () {
    if (!this.$options.propsData.attendee && !this.$options.propsData.bookingData) {
      this.$router.replace('/')
    }
  }
}
</script>

<style lang="scss" module>
.box {
  max-width: 1200px;
  margin-top: 280px;
}
</style>
